import React from "react";

const NotifyBadge = ({ count }) => {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  const digits = Math.min(String(n).length, 5);
  return (
    <div className={`badge badge-dot notifyBadge digits-${digits}`}>
      {n}
    </div>
  );
};

export default NotifyBadge;
